import React from "react"
import useGlobal from "../../context/GlobalContext"
import Dropdown from "react-dropdown"
import { navigate } from "gatsby"

export default function LanguageToggle() {
  const { languageOptions, pageContext } = useGlobal()
  function handelNavigate(item) {
    if (item.value === "en-in") {
      return navigate(pageContext.url)
    }
    return navigate(`/${item.value}${pageContext.url}`)
  }
  return (
      <Dropdown
        options={languageOptions}
        onChange={handelNavigate}
        value={languageOptions.find(
          (item) =>
            item.value === pageContext.langKey ||
            item.lang === pageContext.langKey
        )}
      />
    )
}
